import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'createdBy',
})
export class CreatedByPipe implements PipeTransform {
  transform(value: string): any {
    let multiplier = {};
    if (value) {
      multiplier = JSON.parse(value);
      if (multiplier['name'] == 'Finance Admin') {
        return 'NCC Representative';
      } else if (multiplier['name']) {
        return multiplier['name'];
      } else if (multiplier['username']) {
        return multiplier['username'];
      } else if (multiplier['first_name'] || multiplier['last_name']) {
        return `${multiplier['first_name']} ${multiplier['last_name']}`;
      } else {
        return multiplier['app_user_email'];
      }
    } else {
      return '-';
    }

    // return multiplier['name'] ? multiplier['name'] : multiplier['appUserId'];
  }
}
